/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import { first, inRange } from 'lodash';
import moment from 'moment';
import { createSelector } from 'reselect';

import { has529Only } from 'state/view/ViewSelectors';

import { getCustomerAge } from 'state/customer/CustomerSelectors';

import { DATE_DISPLAY_FORMAT } from 'services/Dates';

export const getMonteCarloConfidenceScore = (state) =>
  state.monteCarloConfidenceScores;
export const getConfidenceScore = (state) => first(state.confidenceScores);

export const hasConfidenceScore = createSelector(
  getConfidenceScore,
  (confidenceScore) => confidenceScore && confidenceScore.scoreValue > 0
);

export const hasMonteCarloConfidenceScore = createSelector(
  getMonteCarloConfidenceScore,
  (confidenceScore) => confidenceScore && confidenceScore.probabilityOfSuccess
);

export const isAgeQualified = createSelector(getCustomerAge, (customerAge) =>
  inRange(customerAge, 50, 70)
);

export const getConfidenceScoreValue = createSelector(
  hasConfidenceScore,
  getConfidenceScore,
  (hasScore, confidenceScore) => (hasScore ? confidenceScore.scoreValue : null)
);

export const getConfidenceScoreDate = createSelector(
  hasConfidenceScore,
  getConfidenceScore,
  (hasScore, confidenceScore) =>
    hasScore
      ? moment.utc(confidenceScore.scoreDate).format(DATE_DISPLAY_FORMAT)
      : null
);

export const showFuturePath = createSelector(
  has529Only,
  isAgeQualified,
  hasConfidenceScore,
  (only529, ageQualified, hasScore) => !only529 && (ageQualified || hasScore)
);

export const getMonteCarloConfidenceScoreTargetText = createSelector(
  hasMonteCarloConfidenceScore,
  getMonteCarloConfidenceScore,
  (hasConfidenceScore, confidenceScore) =>
    hasConfidenceScore && confidenceScore.targetText
);

export const getMonteCarloConfidenceScoreTargets = createSelector(
  hasMonteCarloConfidenceScore,
  getMonteCarloConfidenceScore,
  (hasConfidenceScore, confidenceScore) => {
    if (hasConfidenceScore) {
      const { targetRangeLow, targetRangeHigh, probabilityOfSuccess } =
        confidenceScore;
      return {
        targetRangeLow: parseInt(targetRangeLow),
        targetRangeHigh: parseInt(targetRangeHigh),
        probabilityOfSuccess: parseInt(probabilityOfSuccess)
      };
    }

    return {
      targetRangeLow: 0,
      targetRangeHigh: 0,
      probabilityOfSuccess: 0
    };
  }
);
